import dynamicLocalization from "@/mixins/dynamic-localization";
import PartyCircles from "@/components/PartyCircles.vue";
import Tag from "@/components/Tag.vue";

export default {
  props: {
    accentClass: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: Array,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    partyIds: {
      type: Array,
      required: true,
    },
    ticketShopId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    authenticated: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullSize: {
      type: Boolean,
      required: false,
      default: false,
    },
    soldOut: {
      type: Boolean,
      required: false,
      default: false,
    },
    ignoreTicketSaleStart: {
      type: Boolean,
      required: false,
      default: false,
    },
    availableSoon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    PartyCircles,
    Tag,
  },
  computed: {
    priceInt() {
      return Math.floor(this.price);
    },
    priceFrac() {
      const frac = Math.floor((this.price - this.priceInt) * 100);
      return frac < 10 ? "0" + frac : frac;
    },
  },
  mixins: [dynamicLocalization],
};
